export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-twitter-40b0b2eb280e86f73e62eb53b83352fc.svg";